import { QueryClient } from '@tanstack/react-query';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

/**
 * Shared TanStack Query client.
 *
 * Defaults are chosen to preserve the semantics of the legacy hand-rolled
 * useApi hook (no retries, no focus/reconnect refetching) while adding a
 * 5-minute stale-while-revalidate cache on top.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: FIVE_MINUTES_MS,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    mutations: {
      retry: false,
    },
  },
});
